const NEW_SURVEY = "NEW_SURVEY";

export const startCategory = params => {
    return {
        type: NEW_SURVEY
    }
};
